import {
  CellClickedEvent,
  ColDef,
  GroupCellRendererParams,
} from '@ag-grid-community/core'
import { AgGridReact } from '@ag-grid-community/react'
import { Button } from '@sureco/design-system'
import React, { useState } from 'react'
import { ApplicationInfo } from 'types/application'
import ApplicationListColDefs from '../ApplicationListColDefs'
import { useBenefitQueue } from '../hooks/useBenefitQueue'
import { useRemoveAssignee } from '../hooks/useRemoveAssignee'
interface ApplicationListContainerProps {
  assignee: string
}

function openApplicationDetails(benefitId: string) {
  const options = `width=600, height=${screen.height}, top=0, left=0`
  const url = `/application-manager/${benefitId}`
  window.open(url, 'appWindow', options)
}

export const ApplicationListContainer = ({
  assignee,
}: ApplicationListContainerProps) => {
  const [rowData, setRowData] = useState([])
  const { removeAssigneeFromQueue, isRemoving } = useRemoveAssignee()
  useBenefitQueue(setRowData, assignee)

  const [colDefs] = useState<ColDef[]>([
    ...ApplicationListColDefs,
    {
      field: 'actions',
      headerName: '',
      cellRenderer: (params: GroupCellRendererParams) => {
        return (
          <div
            style={{
              display: 'flex',
              height: '100%',
              gap: '8px',
              alignItems: 'center',
            }}
          >
            <Button
              size="small"
              color="primary"
              disabled={isRemoving}
              onClick={() => {
                removeAssigneeFromQueue(
                  params.data.benefitId,
                  params.data.name,
                  assignee,
                  () => {
                    setRowData((prevData) =>
                      prevData.filter(
                        (item: ApplicationInfo) =>
                          item.benefitId !== params.data.benefitId
                      )
                    )
                  },
                  params.data.employeePublicKey
                )
              }}
            >
              {isRemoving ? 'Removing...' : 'Remove from queue'}
            </Button>
          </div>
        )
      },
    },
  ])

  return (
    <div
      className="ag-theme-alpine"
      style={{ width: '100%', height: 'calc(100vh - 260px)' }}
    >
      <AgGridReact
        columnDefs={colDefs}
        rowData={rowData}
        onCellClicked={(event: CellClickedEvent): void => {
          if (event.column.getColId() !== 'actions') {
            openApplicationDetails(event.data.benefitId)
          }
        }}
        debug={false}
      />
    </div>
  )
}
